import { IconButton, IStackStyles, Stack } from '@fluentui/react';
import React, { useState } from 'react';
import OverflowSetVerticalSideNav from './OverflowSetVerticalSideNav';
import styles from './SideNavigation.module.scss'
const SideNavigation: React.FunctionComponent = () => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  const navStyles = (isCollapsed: boolean): IStackStyles => ({
    root: isCollapsed ? styles.sideNavRoot : styles.sideNavExpanded,
  });

  return (
    <Stack styles={navStyles(isCollapsed)}>
      <Stack horizontalAlign={isCollapsed ? "start" : "center"}>
        <IconButton
          iconProps={{ iconName: isCollapsed ? 'GlobalNavButton' : 'Cancel' }}
          onClick={toggleCollapse}
          ariaLabel="Toggle Navigation"
          styles={{ root: { marginBottom: 10 } }}
        />
      </Stack>
      <OverflowSetVerticalSideNav isCollapsed={isCollapsed} />
    </Stack>
  );
};

export default SideNavigation;